import React from 'react';
// import flexible from '../../utils/flexible';
import './index.less';

class InvoiceConfirmation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '申请开具增值税专用发票确认书';
    return (
        <div className="page_type_h5">
            <div id="invoiceConfirmation">
                <article>
                    <h2>申请开具增值税专用发票确认书</h2>
                    <section>
                        根据国家税法及发票管理相关规定,任何单位和个人不得要求他人为自己开具与实际经营业务情况不符的增值税专用发票【包括并不限于(1)在没有货物采购或者没有接受应税劳务的情况下要求他人为自己开具增值税专用发票;(2)虽有货物采购或者接受应税劳务但要求他人为自己开具数量或金额与实际情况不符的增值税专用发票】,否则属于“虚开增值税专用发票”。
                    </section>
                    <section>
                        充电服务商下的订单暂不支持开票，可另行找所属服务商开具发票；
                    </section>
                    <section>
                        我已充分了解上述各项相关国家税法和发票管理规定,并确认仅就我司实际购买商品或服务索取发票。如我司未按国家相关规定申请开具或使用增值税专用发票,由我司自行承担相应法律后果。
                    </section>
                </article>
            </div>
        </div>
    );
  }
}

export default InvoiceConfirmation;



// WEBPACK FOOTER //
// ./src/staticPage/invoiceConfirmation/index.js